import {
  myProjectSortDirectionOptions,
  myProjectSortOptions
} from '../../react-query/project/query/use-get-my-projects-query'
import {
  projectTreeSortByOptions,
  projectTreeSortDirectionOptions,
  projectTreeStateFilterOptions
} from '../../react-query/project/query/use-get-project-tree-query'
import { useProjectMenuStore } from '../../zustand/project-menu/use-project-menu-store'

const myProjectSortValues = Object.values(myProjectSortOptions)
const projectTreeSortValues = Object.values(projectTreeSortByOptions)

export const defaultMyProjectsSorting = {
  id: myProjectSortOptions.LAST_MODIFIED,
  desc: true
}

/**
 * `sort`/`dir` are shared by both tabs, so a value left over from the other tab
 * — or a hand-edited URL — falls back to this tab's default instead of being
 * sent to the backend.
 */
export const resolveMyProjectsSorting = ({ sortId, sortDirection } = {}) => {
  if (!myProjectSortValues.includes(sortId)) return defaultMyProjectsSorting

  return {
    id: sortId,
    desc: sortDirection !== myProjectSortDirectionOptions.ASC
  }
}

export const defaultCompanyProjectsSorting = {
  id: projectTreeSortByOptions.LAST_ACTIVITY,
  desc: true
}

/** Same fallback as `resolveMyProjectsSorting`, against the project tree enum. */
export const resolveCompanyProjectsSorting = ({
  sortId,
  sortDirection
} = {}) => {
  if (!projectTreeSortValues.includes(sortId)) {
    return defaultCompanyProjectsSorting
  }

  return {
    id: sortId,
    desc: sortDirection !== projectTreeSortDirectionOptions.ASC
  }
}

/**
 * Turns the URL search params into the query params of the my-projects list.
 * Shared by the route loader and the table so both hit the exact same query key.
 */
export const resolveMyProjectsQueryParams = ({
  q,
  page,
  size,
  sort,
  dir
} = {}) => {
  const { id, desc } = resolveMyProjectsSorting({
    sortId: sort,
    sortDirection: dir
  })

  return {
    search: q ?? '',
    page: page ?? 0,
    // callers inside React pass the size already resolved by
    // `useProjectMenuListViewControl`; the route loader relies on this fallback
    size: size ?? useProjectMenuStore.getState().projectListPageSize,
    projectSort: id,
    sortDirection: desc
      ? myProjectSortDirectionOptions.DESC
      : myProjectSortDirectionOptions.ASC
  }
}

/** Same contract as above, for the company projects list. */
export const resolveCompanyProjectsQueryParams = ({
  q,
  page,
  size,
  sort,
  dir,
  inactive
} = {}) => {
  const { id, desc } = resolveCompanyProjectsSorting({
    sortId: sort,
    sortDirection: dir
  })

  return {
    search: q ?? '',
    page: page ?? 0,
    size: size ?? useProjectMenuStore.getState().projectListPageSize,
    sortBy: id,
    sortDirection: desc
      ? projectTreeSortDirectionOptions.DESC
      : projectTreeSortDirectionOptions.ASC,
    stateFilter: inactive
      ? projectTreeStateFilterOptions.ALL
      : projectTreeStateFilterOptions.ACTIVE
  }
}
